var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.39,49.61h4.3a3,3,0,0,0,3-3V46c2.6,1.32,8.5,3.63,18.09,3.63h2.75a8.13,8.13,0,0,0,8-6.77l1.92-11.16a8.16,8.16,0,0,0-8-9.55h-7.8a15.94,15.94,0,0,0,1-5.58c0-6.46-3.66-8.16-5.59-8.16-3.56,0-3.86,3.32-3.86,6.44,0,3.8-4.27,7-6.52,8.37a3,3,0,0,0-3-2.79h-4.3a3,3,0,0,0-3,3V46.61a3,3,0,0,0,3,3ZM27.77,14.83c0-3.87.65-3.87,1.28-3.87,1.21,0,3,1.49,3,5.59a12.17,12.17,0,0,1-1.5,6.15,1.29,1.29,0,0,0,1.07,2h9.83A5.59,5.59,0,0,1,47,31.24L45,42.4A5.56,5.56,0,0,1,39.53,47H36.78c-11.68,0-17.54-3.66-18.09-4V26.17c1.43-.76,9.08-5.11,9.08-11.34ZM11,23.42a.43.43,0,0,1,.43-.43h4.3a.43.43,0,0,1,.43.43V46.61a.44.44,0,0,1-.43.43h-4.3a.43.43,0,0,1-.43-.43Z",
    style: {
      fill: "#30373d"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like_icon.77ec884330a72d23ddba6bf28e66d6fc.svg";
export { ForwardRef as ReactComponent };